import { render, staticRenderFns } from "./DuplicateItemModal.vue?vue&type=template&id=263918c6"
import script from "./DuplicateItemModal.vue?vue&type=script&lang=js"
export * from "./DuplicateItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports